import { Capacitor } from '@capacitor/core';

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || '');
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(new Error('Không đọc được file PDF'));
    reader.readAsDataURL(blob);
  });
}

function triggerBrowserDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1500);
}

/** Lưu PDF về máy: APK/IPA mở Share để lưu file; trình duyệt tải trực tiếp. */
export async function savePdfToDevice(blob: Blob, filename: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    try {
      const [{ Directory, Filesystem }, { Share }] = await Promise.all([
        import('@capacitor/filesystem'),
        import('@capacitor/share'),
      ]);
      const data = await blobToBase64(blob);
      const saved = await Filesystem.writeFile({
        path: filename,
        data,
        directory: Directory.Cache,
      });
      await Share.share({
        title: 'Hợp đồng thuê nhà',
        text: filename,
        files: [saved.uri],
        dialogTitle: 'Lưu PDF về máy',
      });
      return;
    } catch {
      triggerBrowserDownload(blob, filename);
      return;
    }
  }

  triggerBrowserDownload(blob, filename);
}
